<template>
   <motion.div
      :initial="{ opacity: 0 }"
      :transition="defaultTransition(delay)"
      :inView="animateInView ? defaultAnimate() : undefined"
      :animate="animateInView ? undefined : defaultAnimate()"
      :inViewOptions="defaultInViewOptions"
   >
      <slot />
   </motion.div>
</template>

<script lang="ts" setup>
import {
   defaultAnimate,
   defaultInViewOptions,
   defaultTransition,
} from '../../composables/animation'

import { motion } from 'motion-v'

type Props = {
   delay?: number
   animateInView?: boolean
}

withDefaults(defineProps<Props>(), {
   delay: 0,
   animateInView: true,
})
</script>
